import { Fragment, useState } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { useAuth } from 'model/Auth';
import { routeLabelList } from 'model/Route';
import { generalStyle, mediaQurey, zIndex } from 'helper/Style';
import { convertUserName } from 'helper/Converter';
import OperationFilter from 'component/part/OperationFilter';
import Svg from 'component/part/Svg';

export type HeaderProps = Readonly<{
  className?: string;
}>;

const env = process.env.REACT_APP_ENVIRONMENT;

const style = {
  layout: (logined: boolean) => ({
    display: 'grid',
    gridTemplateColumns: logined ? 'auto 1fr auto auto' : 'auto 1fr',
    gap: '4rem',
    alignItems: 'center',
    backgroundColor: {
      production: '#073f99',
      staging: '#bb0066',
      local: '#ff66aa',
    }[env || ''] || '#073f99',
    color: '#ffffff',
    fontSize: '1.6rem',
    ['& > div']: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
    [mediaQurey('max', 'tablet')]: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  }),
  title: {
    paddingLeft: '3rem',
  },
  userCommandArea: {
    position: 'relative' as const,
    justifiContent: 'right',
  },
  userCommandOperator: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '0 1rem',
    cursor: 'pointer',
    ['& img']: {
      width: '3rem',
    },
    ['&:hover']: {
      backgroundColor: '#ffffff44',
    },
  },
  userCommand: {
    position: 'absolute' as const,
    top: '100%',
    right: '0',
    backgroundColor: '#000000',
    whiteSpace: 'nowrap',
    fontSize: '1.6rem',
    zIndex: zIndex.filter + 1,
    ['&:not([data-display="1"])']: {
      display: 'none',
    },
    ['& > div']: {
      padding: '1rem',
      cursor: 'pointer',
    },
    ['& > div:nth-of-type(n+2):hover']: {
      backgroundColor: '#444444',
    },
    ['& a']: {
      textDecoration: 'none',
      color: '#ffffff',
    },
  },
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathParts = location.pathname.match(/^\/([a-z]+)(\/([a-z]+))?/);
  const route = pathParts?.[1] || 'home';
  const routeLabel = routeLabelList[route] || 'ホーム';

  return <div css={generalStyle.onlyPc}>
    {routeLabel}
  </div>;
};

const Header = (props: HeaderProps) => {
  const auth = useAuth();
  const [userCommandDisplay, setUserCommandDisplay] = useState(false);

  const executeLogout = async () => {
    await auth.logout();
  };

  return <div className={props.className} css={style.layout(!!auth.user)}>
    <div css={style.title}>
      工事台帳管理システム
      {env === 'staging' && '（検証環境）'}
      {env === 'local' && '（開発環境）'}
    </div>
    <Breadcrumbs />
    {auth.user && (
      <Fragment>
        <div css={generalStyle.onlyPc}>株式会社シンクリエイト</div>
        <div onClick={() => setUserCommandDisplay(!userCommandDisplay)} css={style.userCommandArea}>
          <div css={[style.userCommandOperator, generalStyle.onlyPc]}>
            {convertUserName(auth.user)}さん
          </div>
          <div css={[style.userCommandOperator, generalStyle.nonPc]}>
            <Svg src='/image/icon/list.svg' color='#ffffff' />
          </div>
          <div data-display={userCommandDisplay ? '1' : '0'} css={style.userCommand}>
            <div css={generalStyle.nonPc}>
              {convertUserName(auth.user)}さん
            </div>
            <div>
              <NavLink to='/mypage/password'>パスワード変更</NavLink>
            </div>
            <div onClick={executeLogout}>
              ログアウト
            </div>
          </div>
        </div>
        <OperationFilter display={userCommandDisplay} onHide={() => setUserCommandDisplay(false)} />
      </Fragment>
    )}
  </div>
};

export default Header;
